import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash (like #book-meeting), scroll to that element smoothly
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // For regular navigation, instantly jump to top (override smooth scroll)
      // Temporarily disable smooth scrolling
      const htmlElement = document.documentElement;
      const originalBehavior = htmlElement.style.scrollBehavior;
      htmlElement.style.scrollBehavior = 'auto';
      
      // Scroll to top instantly
      window.scrollTo(0, 0);
      
      // Restore smooth scrolling after a brief delay
      setTimeout(() => {
        htmlElement.style.scrollBehavior = originalBehavior;
      }, 50);
    }
  }, [pathname, hash]);

  return null;
};
